import React, { useEffect, useState, useCallback } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
// import { getBulanName } from "../helper/function";
import { fetchApi } from "../helper/api";
import {
  Divider,
  TextField,
  IconButton,
  Button,
  Tooltip as MuiTooltip,
} from "@mui/material";
import Select from "react-select";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TagIcon from "@mui/icons-material/Tag";
import { LineChart } from "../component/template/LineChart";
import { HelpOutline as HelpIcon } from "@mui/icons-material";
import { IsAlert } from "../component/atoms/IsAlert";
import { saveAs } from "file-saver";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function HomeEdit() {
  const defaultOptions = [{ value: null, label: "NONE" }];
  const defaultDataForGraph = { daily: null, monthly: null, anual: null };
  const [dataForGraph, setDataForGraph] = useState(defaultDataForGraph);
  const [datePicker, setDatePicker] = useState(null);
  const [datePickerDownload, setDatePickerDownload] = useState(null);
  const [datePickerDefaultValue, setDatePickerDefaultValue] = useState(null);
  const [allBridges, setAllBridges] = useState(null);
  const [selectedBridges, setSelectedBridges] = useState(null);
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [bridgeSensor, setBridgeSensor] = useState(null);
  const [bridgeOptions, setBridgeOptions] = useState(defaultOptions);
  const [sensorOptions, setSensorOptions] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const options = (type) => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        bar: {
          borderWidth: 2,
        },
      },
      plugins: {
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 30,
          },
        },
        title: {
          display: false,
          text: "",
        },
        tooltip: {
          callbacks: {
            title: (p) => {
              // console.log(p);
              return type;
            },
            label: (p) => {
              return `Threshold ${p.dataset.label}: ${p.raw} kali`;
            },
          },
          mode: "index",
          intersect: true,
        },
      },
      scales: {
        y: {
          title: {
            display: true,
            text: "Jumlah Event Melewati Threshold",
          },
        },
      },
    };
  };

  useEffect(() => {
    fetchAllBridges();
  }, []);

  useEffect(() => {
    if (selectedBridges) {
      fetchSensor(selectedBridges?.value);
    }
  }, [allBridges, selectedBridges]);

  useEffect(() => {
    if (selectedBridges && selectedSensor && datePicker) {
      fetchDataForGraph();
    } else {
      setDataForGraph(defaultDataForGraph);
    }
  }, [selectedBridges, selectedSensor, datePicker]);

  const fetchSensor = async (ipc) => {
    const data = await fetchThis(`api/Rtu/ipc/${ipc}`);
    if (data) {
      setBridgeSensor(data);
      let tempGroupOptions = [];
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          let tempOptions = [];
          for (let i = 0; i < data[key].length; i++) {
            tempOptions.push({
              value: data[key][i]?.idSensor,
              label: `${key} ${data[key][i]?.numberSensor}`,
            });
          }
          tempGroupOptions.push({
            label: key,
            options: tempOptions,
          });
          setSensorOptions((current) => {
            return [current, ...tempGroupOptions];
          });
        }
      }
    }
  };

  const fetchAllBridges = async () => {
    const data = await fetchThis("api/Bridge");
    if (data) {
      setAllBridges(data);
      let tempBridgeOption = [];
      data.map((bridge) => {
        console.log("Test", bridge?.ipcs[0]?.serialNumberIpc.includes("IPCC"));
        if (!bridge?.ipcs[0]?.serialNumberIpc.includes("IPCC")) {
          tempBridgeOption.push({
            value: bridge?.ipcs[0]?.serialNumberIpc,
            label: bridge?.namaJembatan,
          });
        }
      });
      setBridgeOptions(tempBridgeOption);
    }
  };

  const fetchDataForGraph = async () => {
    const daily = await fetchThis(
      `api/ThresholdHistory/perhari?sensor=${selectedSensor?.value}&dateTime=${datePicker}`
    );

    const monthlyDate = datePicker?.substring(0, 5);
    const monthly = await fetchThis(
      `api/ThresholdHistory/perbulan?sensor=${selectedSensor?.value}&dateTime=${monthlyDate}`
    );

    const anualDate = datePicker?.substring(0, 2);
    const anual = await fetchThis(
      `api/ThresholdHistory/pertahun?sensor=${selectedSensor?.value}&dateTime=${anualDate}`
    );

    const label = ["Warning", "Danger"];
    const emptyData = {
      labels: label,
      datasets: [
        {
          label: "max",
          data: [],
          borderColor: "#FF0015",
          backgroundColor: "#FF0015a9",
          barThickness: 50,
        },
        {
          label: "min",
          data: [],
          borderColor: "#f1f137",
          backgroundColor: "#f1f137a9",
          barThickness: 50,
        },
      ],
    };

    const getValue = (array) => {
      const warningMinValue =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Warning Min")
        ]?.avgValue;
      const warningMinCount =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Warning Min")
        ]?.count;
      const warningMaxValue =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Warning Max")
        ]?.avgValue;
      const warningMaxCount =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Warning Max")
        ]?.count;

      const dangerMinValue =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Danger Min")
        ]?.avgValue;
      const dangerMinCount =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Danger Min")
        ]?.count;
      const dangerMaxValue =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Danger Max")
        ]?.avgValue;
      const dangerMaxCount =
        array[0].datas[
          array[0].datas.findIndex((find) => find.status === "Danger Max")
        ]?.count;

      return {
        warningMinCount,
        warningMaxCount,
        dangerMinCount,
        dangerMaxCount,
        warningMinValue,
        warningMaxValue,
        dangerMinValue,
        dangerMaxValue,
      };
    };

    let isDailyEmpty = false;
    let isMonthlyEmpty = false;
    let isAnualEmpty = false;
    if (daily?.length !== 0) {
      // console.log("DAILY", daily);
      const data = getValue(daily);
      setDataForGraph((current) => {
        return {
          ...current,
          daily: {
            ...emptyData,
            datasets: [
              {
                ...emptyData.datasets[0],
                data: [
                  data.warningMaxCount ? data.warningMaxCount : 0,
                  data.dangerMaxCount ? data.dangerMaxCount : 0,
                ],
              },
              {
                ...emptyData.datasets[1],
                data: [
                  data.warningMinCount ? data.warningMinCount : 0,
                  data.dangerMinCount ? data.dangerMinCount : 0,
                ],
              },
            ],
          },
        };
      });
    } else {
      isDailyEmpty = true;
    }

    if (monthly?.length !== 0) {
      // console.log("MONTHLY", monthly);
      const data = getValue(monthly);
      setDataForGraph((current) => {
        return {
          ...current,
          monthly: {
            ...emptyData,
            datasets: [
              {
                ...emptyData.datasets[0],
                data: [
                  data.warningMaxCount ? data.warningMaxCount : 0,
                  data.dangerMaxCount ? data.dangerMaxCount : 0,
                ],
              },
              {
                ...emptyData.datasets[1],
                data: [
                  data.warningMinCount ? data.warningMinCount : 0,
                  data.dangerMinCount ? data.dangerMinCount : 0,
                ],
              },
            ],
          },
        };
      });
    } else {
      isMonthlyEmpty = true;
    }

    if (anual?.length !== 0) {
      // console.log("ANUAL", anual);
      const data = getValue(anual);
      setDataForGraph((current) => {
        return {
          ...current,
          anual: {
            ...emptyData,
            datasets: [
              {
                ...emptyData.datasets[0],
                data: [
                  data.warningMaxCount ? data.warningMaxCount : 0,
                  data.dangerMaxCount ? data.dangerMaxCount : 0,
                ],
              },
              {
                ...emptyData.datasets[1],
                data: [
                  data.warningMinCount ? data.warningMinCount : 0,
                  data.dangerMinCount ? data.dangerMinCount : 0,
                ],
              },
            ],
          },
        };
      });
    } else {
      isAnualEmpty = true;
    }

    if (isDailyEmpty || isMonthlyEmpty || isAnualEmpty) {
      let text = `${isDailyEmpty ? " perhari" : ""}`;
      text = `${text}${isMonthlyEmpty ? " perbulan" : ""}`;
      text = `${text}${isAnualEmpty ? " pertahun" : ""}`;
      alert(`Data threshold${text} di tanggal ${datePicker}, kosong`);
    }
  };

  const fetchThis = async (url) => {
    let tempData = null;
    const req = await fetchApi(url, "GET", true);
    const res = await req.json();
    const { data } = res;
    const { status } = req;
    if (status === 200) {
      if (data) {
        // console.log(`DATA FETCH ${url}: `, data);
        tempData = data;
      }
    } else {
      console.log(`ERROR FETCH ${url}`);
    }
    return tempData;
  };

  const handleSelect = (selectedOptions, id) => {
    if (id === "bridge") {
      setSelectedBridges(selectedOptions);
      setSelectedSensor(null);
      setDatePicker(null);
      setDatePickerDefaultValue(null);
      setDataForGraph(defaultDataForGraph);
    } else if (id === "sensor") {
      // console.log("sensorOP", selectedOptions);
      setSelectedSensor(selectedOptions);
      // setDatePicker(null);
      // setDatePickerDefaultValue(null);
      setDataForGraph(defaultDataForGraph);
    }
  };

  const handleDatePicker = (e) => {
    if (e !== null) {
      const date = new Date(e);
      const localDate = date?.toLocaleDateString();
      // const newDate = localDate.replace(/\//g, "-");
      const split = localDate?.split("/");
      const yearFull = split[2];
      const year = split[2]?.substring(2, 4);
      const month = split[0];
      const day = split[1];
      let newDay;
      let newMonth;
      let newYear;
      if (Number.parseInt(day) < 10) {
        newDay = `0${day}`;
      } else {
        newDay = day;
      }

      if (Number.parseInt(month) < 10) {
        newMonth = `0${month}`;
      } else {
        newMonth = month;
      }
      newYear = year;
      const formatedDate = `${newYear}-${newMonth}-${newDay}`;
      setDatePicker(formatedDate);
      setDatePickerDownload(`${yearFull}-${newMonth}-${newDay}`);
      setDatePickerDefaultValue(e);
    }
  };

  const renderTitle = useCallback(() => {
    if (datePicker != null) {
      // console.log("Date", datePicker);
      return <span style={{ color: "#2196F3" }}>20{datePicker}</span>;
    } else {
      return <></>;
    }
  }, [datePicker]);

  const handleDownloadPlayback = useCallback(async () => {
    if (!selectedBridges || !selectedSensor || !datePickerDownload) {
      IsAlert.fire({
        icon: "warning",
        title: "Perhatian",
        text: "Pastikan jembatan, sensor, dan tanggal telah terisi terlebih dahulu untuk mendapatkan data statistik",
        showCancelButton: false,
        showConfirmButton: true,
      });
      return;
    }
    setLoadingDownload(true);
    try {
      const from = datePickerDownload;
      const to = datePickerDownload;
      const url = `api/Data/downloadStatistic?idSensor=${selectedSensor?.value}&from=${from}&to=${to}`;
      const filename = `Playback Data ${selectedSensor?.label} - ${from}`;
      const req = await fetchApi(url, "get_blob", true);
      const res = await req.blob();
      saveAs(res, `${filename}.csv`);
    } catch (error) {
    } finally {
      setLoadingDownload(false);
    }
  }, [datePickerDownload, selectedBridges, selectedSensor]);

  return (
    <div
      className="shadow"
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        padding: "2em",
        borderRadius: "20px",
        // height: "100%",
      }}
    >
      <h1 className="text-center">Dashboard</h1>
      <div
        style={{
          margin: "10px 0px 20px 0px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "30px",
        }}
      >
        <div style={{ minWidth: "250px" }}>
          <Select
            menuPlacement="auto"
            menuPosition="fixed"
            options={bridgeOptions}
            onChange={(e) => handleSelect(e, "bridge")}
            placeholder="Pilih jembatan"
          />
        </div>
        <div style={{ minWidth: "250px" }}>
          <Select
            value={selectedSensor}
            menuPlacement="auto"
            menuPosition="fixed"
            options={sensorOptions}
            isDisabled={sensorOptions.length <= 0}
            onChange={(e) => handleSelect(e, "sensor")}
            placeholder="Pilih Sensor"
          />
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            disabled={!selectedSensor}
            label="Tanggal"
            inputFormat="MM/DD/YYYY"
            // views={translateFormatDatePicker(timeOption.toLowerCase())}
            value={datePickerDefaultValue && datePickerDefaultValue}
            onAccept={(e) => {
              handleDatePicker(e["$d"]);
            }}
            onChange={(e) => setDatePickerDefaultValue(e)}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: `Pilih Tanggal`,
                }}
              />
            )}
          />
        </LocalizationProvider>

        <button
          className={`btn ${
            loadingDownload ||
            !datePickerDownload ||
            !selectedBridges ||
            !selectedSensor
              ? "btn-light"
              : "btn-success"
          } ml-3 d-flex align-items-center`}
          onClick={() => handleDownloadPlayback()}
          disabled={
            loadingDownload ||
            !datePickerDownload ||
            !selectedBridges ||
            !selectedSensor
          }
        >
          <i className="las la-save mr-2" style={{ fontSize: 24 }}></i>
          Download
        </button>
      </div>
      <Divider />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px",
          gap: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            // height: "fit-content",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <TagIcon />
            <h2
              style={{
                margin: "10px 0px",
                padding: "0px",
                fontWeight: "400",
              }}
            >
              Data Statistik {renderTitle()}
            </h2>
            <MuiTooltip
              title="Data statistik digenerate per interval waktu dan tidak realtime, data yang disimpan di database akan diolah scara otomatis setiap 10 menit untuk menghitung nilai rata - rata, maksimal dan minimal"
              placement="right"
              arrow
            >
              <IconButton color="info">
                <HelpIcon />
              </IconButton>
            </MuiTooltip>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LineChart sensor={selectedSensor} date={datePicker} />
          </div>
        </div>

        <Divider />

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <TagIcon />
            <h2
              style={{
                margin: "10px 0px",
                padding: "0px",
                fontWeight: "400",
              }}
            >
              Threshold Perhari
            </h2>
          </span>
          <div
            style={{
              display: "flex",
              width: "97%",
              height: "350px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Bar options={options("Harian")} data={dataForGraph.daily} />
          </div>
        </div>

        <Divider />

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <TagIcon />
            <h2
              style={{
                margin: "10px",
                padding: "0px",
                fontWeight: "400",
              }}
            >
              Threshold Perbulan
            </h2>
          </span>
          <div
            style={{
              display: "flex",
              width: "97%",
              height: "350px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Bar options={options("Bulanan")} data={dataForGraph.monthly} />
          </div>
        </div>

        <Divider />

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <TagIcon />
            <h2
              style={{
                margin: "10px",
                padding: "0px",
                fontWeight: "400",
              }}
            >
              Threshold Pertahun
            </h2>
          </span>
          <div
            style={{
              display: "flex",
              width: "97%",
              height: "350px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Bar options={options("Tahunan")} data={dataForGraph.anual} />
          </div>
        </div>
      </div>
    </div>
  );
}
